import { render, staticRenderFns } from "./ErrorMessage.vue?vue&type=template&id=6e4074e2&"
import script from "./ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./ErrorMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e4074e2')) {
      api.createRecord('6e4074e2', component.options)
    } else {
      api.reload('6e4074e2', component.options)
    }
    module.hot.accept("./ErrorMessage.vue?vue&type=template&id=6e4074e2&", function () {
      api.rerender('6e4074e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8nBPJ0poyi4xR/JS/comp/ErrorMessage.vue"
export default component.exports